import { motion, AnimatePresence } from "framer-motion";
import { FaTelegram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

const menuItems = [
  { id: 'Web3', label: 'Web3' },
  { id: 'Presale', label: 'Pre-Sale' },
  { id: 'Live', label: 'Live!' },
  { id: 'Ciphegis', label: 'Ciphegis' },
  { id: 'Supply', label: 'Supply' },
  { id: 'Staking', label: 'Staking' },
  { id: 'Roadmap', label: 'Roadmap' },
];

const socialLinks = [
  {
    name: 'Telegram',
    url: 'https://t.me/ciphegis2050',
    icon: FaTelegram
  },
  {
    name: 'Twitter',
    url: 'https://x.com/ciphegis',
    icon: FaXTwitter
  }
];

const MobileNavbar = ({ show, onClose }) => {

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40"
            onClick={onClose}
          />

          {/* Menu */}
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed right-0 top-0 h-screen w-64 bg-black border-l border-[#22C8BF]/20 z-50 p-6"
          >
            <div className="flex flex-col h-full">
              {/* Close button */}
              <button
                onClick={onClose}
                className="self-end p-2 hover:bg-[#22C8BF]/10 rounded-lg transition-colors duration-300 mb-8"
              >
                <span className="text-[#22C8BF] text-xl">×</span>
              </button>

              {/* Navigation items */}
              <nav className="flex flex-col gap-6">
                {menuItems.map((item) => (
                  <motion.button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-left text-white hover:text-[#22C8BF] transition-colors duration-300"
                    whileHover={{ x: 4 }}
                    transition={{ type: "tween" }}
                  >
                    {item.label}
                  </motion.button>
                ))}
                <motion.button
                  className="text-left text-white hover:text-[#22C8BF] transition-colors duration-300"
                  whileHover={{ x: 4 }}
                  transition={{ type: "tween" }}
                >
                  <a href="https://tally.so/r/nG7LrL" target="_blank" rel="noopener noreferrer" className="text-left text-white hover:text-[#22C8BF] transition-colors duration-300"
                  whileHover={{ x: 4 }}
                  transition={{ type: "tween" }}
                  >
                    Sign Up
                  </a>
                </motion.button>
              </nav>

              {/* Social Links */}
              <div className="mt-auto pt-8 border-t border-[#22C8BF]/20">
                <div className="flex items-center gap-4 mb-4">
                  {socialLinks.map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-2 hover:bg-[#22C8BF]/10 rounded-lg transition-all duration-300"
                    >
                      <social.icon
                        className="w-6 h-6 text-white hover:text-[#22C8BF] hover:scale-110 transition-all duration-300"
                      />
                    </a>
                  ))}
                </div>
                <p className="text-white/60 text-sm">© 2025 All rights reserved</p>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default MobileNavbar;
